var _circle, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 150,
    viewBox: "0 0 203 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86.0881,
    cy: 83.4788,
    r: 66.5217,
    fill: "#34C981"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.348 56L74.2422 109.478L53 88.0869",
    stroke: "url(#paint0_linear)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.652 62.6099C167.344 60.4989 172.88 57.5762 178.263 60.1742C183.748 62.8219 186.056 60.4395 187.952 55.1404C190.566 47.8334 199.178 48.1581 200.87 53.5167",
    stroke: "url(#paint1_linear)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0208 24.2097L26.365 18.1234L28.1727 10.0141C28.2735 9.56151 28.1086 9.09087 27.7477 8.80035C27.3868 8.50982 26.892 8.44907 26.4712 8.64442L18.9352 12.1425L11.7811 7.91699C10.9142 7.40502 9.8318 8.11151 9.95283 9.11194L10.9506 17.3604L4.72126 22.8587C3.96661 23.5251 4.30367 24.7735 5.29276 24.9666L13.4458 26.5666C17.0455 34.8707 16.7817 34.3952 17.1036 34.6543C17.3003 34.8127 17.5453 34.9091 17.8074 34.922C18.2703 34.9446 18.7062 34.7031 18.9317 34.2982L22.9726 27.0382L31.2436 26.251C32.2459 26.1562 32.707 24.9486 32.0208 24.2097Z",
    fill: "#FFA92C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1316 23.4841L14.1338 15.2356C14.0129 14.2363 15.0942 13.5282 15.962 14.0407L23.1161 18.2661L26.7047 16.6005L28.1727 10.0141C28.2735 9.56151 28.1086 9.09087 27.7477 8.80035C27.3868 8.50982 26.892 8.44907 26.4712 8.64441L18.9352 12.1425L11.7811 7.91699C10.9142 7.40502 9.8318 8.11151 9.95283 9.11194L10.9506 17.3604L4.72126 22.8587C3.96661 23.5251 4.30367 24.7735 5.29276 24.9666L11.9674 26.2765L15.1316 23.4841Z",
    fill: "#FF8828"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 90.1739,
    y1: 56,
    x2: 90.1739,
    y2: 109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34C981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532EB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 157.788,
    y1: 54.2836,
    x2: 162.754,
    y2: 72.8208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#532EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34C981"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.6b9e0e4caf729b41f1f2111fa1f4114c.svg";
export { ForwardRef as ReactComponent };